import React from 'react';
import { Link } from 'react-router-dom';


const DashboardGuide = _ => {

  return (
    <div className='col-12 p-4'>

      <div className='col-12 d-flex justify-content-between align-items-center'>
        <h3 className="text-right text-muted py-4">
          <div className='text-right'>{locales("titles.RseeDashbaordGuide")}</div>
        </h3>
        {/* <div>
          <Link
            to='/dashboard'
          >
            <button
              className='btn btn-default w-5 mx-1'>
              <i className="fa fa-reply mx-1" />
              {locales('labels.cancel')}
            </button>
          </Link>
        </div> */}
      </div>
      <section className='my-3'>
        <div className='panel-heading'><i className='fas fa-list-alt px-1' />{locales('titles.cafesCalculations')}</div>
        <div className='panel-body'>

          <div className='d-flex border-bottom p-2'>
            <div className='text-dark font-weight-bold px-2'>
              <i className='far fa-info-circle text-info' /> {locales('titles.activeCafesCount')} :
          </div>
            <div className='text-muted'>
              {locales('titles.activeCafesDescription')}
            </div>
          </div>

          <div className='d-flex border-bottom  p-2'>
            <div className='text-dark font-weight-bold px-2'>
              <i className='far fa-info-circle text-info' /> {locales('titles.requestedCafesCount')} :
          </div>
            <div className='text-muted'>
              {locales('titles.requestedCafesCountDescription')}
            </div>
          </div>

          <div className='d-flex border-bottom  p-2'>
            <div className='text-dark font-weight-bold px-2'>
              <i className='far fa-info-circle text-info' /> {locales('titles.cafeCapacityUsagePercentage')} :
          </div>
            <div className='text-muted'>
              {locales('titles.cafeCapacityUsagePercentageDescription')}
            </div>
          </div>


        </div>
      </section>




      <section className='my-3'>
        <div className='panel-heading'><i className='fas fa-list-alt px-1' />{locales('titles.reservesCalculations')}</div>
        <div className='panel-body'>

          <div className='d-flex border-bottom p-2'>
            <div className='text-dark font-weight-bold px-2'>
              <i className='far fa-info-circle text-info' /> {locales('titles.averageCostOfOrderPerReserve')} :
          </div>
            <div className='text-muted'>
              {locales('titles.averageCostOfOrderPerReserveDescription')}
            </div>
          </div>

          <div className='d-flex border-bottom  p-2'>
            <div className='text-dark font-weight-bold px-2'>
              <i className='far fa-info-circle text-info' /> {locales('titles.cancelationPercentageFromClient')} :
          </div>
            <div className='text-muted'>
              {locales('titles.cancelationPercentageFromClientDescription')}
            </div>
          </div>

          <div className='d-flex border-bottom  p-2'>
            <div className='text-dark font-weight-bold px-2'>
              <i className='far fa-info-circle text-info' /> {locales('titles.ChiarsCountAveragePerPerson')} :
          </div>
            <div className='text-muted'>
              {locales('titles.ChiarsCountAveragePerPersonDescription')}
            </div>
          </div>


          <div className='d-flex border-bottom  p-2'>
            <div className='text-dark font-weight-bold px-2'>
              <i className='far fa-info-circle text-info' /> {locales('titles.directReserveCostsAverage')} :
          </div>
            <div className='text-muted'>
              {locales('titles.directReserveCostsAverageDescription')}
            </div>
          </div>


          <div className='d-flex border-bottom  p-2'>
            <div className='text-dark font-weight-bold px-2'>
              <i className='far fa-info-circle text-info' /> {locales('titles.pureWagesAveragePerReserve')} :
          </div>
            <div className='text-muted'>
              {locales('titles.pureWagesAveragePerReserveDescription')}
            </div>
          </div>


        </div>
      </section>



      <section className='my-3'>
        <div className='panel-heading'><i className='fas fa-list-alt px-1' />{locales('titles.RseeCalculations')}</div>
        <div className='panel-body'>

          <div className='d-flex border-bottom p-2'>
            <div className='text-dark font-weight-bold px-2'>
              <i className='far fa-info-circle text-info' /> {locales('titles.RseePureWagesPercentage')} :
          </div>
            <div className='text-muted'>
              {locales('titles.RseePureWagesPercentageDescription')}
            </div>
          </div>
          <small className='text-success mx-3'>
            <i className='fal fa-life-ring' /> {locales('titles.hint')} : {locales('titles.rseeCalculationsHint')}
          </small>

        </div>

      </section>





      <section className='my-3'>
        <div className='panel-heading'><i className='fas fa-list-alt px-1' />{locales('titles.usersCalculations')}</div>
        <div className='panel-body'>

          <div className='d-flex border-bottom p-2'>
            <div className='text-dark font-weight-bold px-2'>
              <i className='far fa-info-circle text-info' /> {locales('titles.activeUsers')} :
          </div>
            <div className='text-muted'>
              {locales('titles.activeUsersDescription')}
            </div>
          </div>
          <small className='text-danger mx-3'>
            <i className='fal fa-exclamation-triangle' /> {locales('titles.caution')} : {locales('titles.activeUsersAlert')}
          </small>

        </div>

      </section>



    </div>
  )
};

export default DashboardGuide;